import SortableTable from './SortableTable';

export { SortableTable };
